<div class="unicity-display" [attr.title]="unicityKind | unicityDisplay: true">
    <mat-icon class="unicity" svgIcon="key" *ngIf="unicityKind"></mat-icon>
    <span>{{ unicityKind | unicityDisplay }}</span>
</div>
